var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "800" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline m-0" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.form.id
                          ? "Editar Programacion"
                          : "Crear parámetros para la programacion de vacaciones"
                      ) +
                      "\n      "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "py-1",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Gestión",
                                  rules: _vm.$validate(["required"]),
                                  type: "number",
                                  required: "",
                                  maxlength: "200",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.form.gestion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "gestion", $$v)
                                  },
                                  expression: "form.gestion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label:
                                    "Porcentaje de vacaciones a programar (%)",
                                  type: "number",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "200",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.form.porcentaje,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "porcentaje", $$v)
                                  },
                                  expression: "form.porcentaje"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Fecha inicio de programación",
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "200",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.form.fecha_inicio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_inicio", $$v)
                                  },
                                  expression: "form.fecha_inicio"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Fecha fin de programación",
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "200",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.form.fecha_fin,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_fin", $$v)
                                  },
                                  expression: "form.fecha_fin"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Días de reserva de la programación",
                                  type: "number",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.form.dias_reserva,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "dias_reserva", $$v)
                                  },
                                  expression: "form.dias_reserva"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label:
                                    "Fecha corte para inicio de programación",
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "200",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.form.fecha_corte,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_corte", $$v)
                                  },
                                  expression: "form.fecha_corte"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Fecha ampliación de programación",
                                  type: "date",
                                  maxlength: "200",
                                  disabled: "",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.form.fecha_ampliacion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_ampliacion", $$v)
                                  },
                                  expression: "form.fecha_ampliacion"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54b77b79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54b77b79","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/parametros_vacacion/dialogs/CrearActualizarProgramacion.vue
// module id = null
// module chunks = 